import Vue from 'vue/dist/vue.min';
import Multiselect from 'vue-multiselect';

const elements = document.querySelectorAll('#common-multiselect');
elements.forEach((element) => {
  new Vue({
    el: element,

    data: function () {
      return {
        value: null,
        options: []
      }
    },

    components: {
      Multiselect
    }
  })
});
